import { FuelButton, FuelIcon, FuelTooltip } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { useDeviceSize } from 'hooks/useDeviceSize';
import React, { FC } from 'react';
import { useTruckerProps } from 'hooks/useTruckerProps';
import { useTruckerNavigation } from 'hooks/useNavigation';
import * as Styled from './styled';
import { IProps } from './types';

const DownloadVerifiedProfile: FC<IProps> = ({ data }) => {
  const { isMobile } = useDeviceSize();
  const { onClose } = useTruckerProps();

  const { handleNavigation } = useTruckerNavigation();

  const handleClick = () => {
    onClose?.();
    handleNavigation(`/pre-consulta/${data?.trucker?.id}`);
  };

  return (
    <FuelFlex
      defaultProps={{
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 'km2',
        customMargin: `${DS_TOKENS.spacing.km4} ${DS_TOKENS.spacing.km0}`,
      }}
      smProps={{ alignItems: 'flex-start', flexDirection: 'column' }}
    >
      <FuelFlex defaultProps={{ alignItems: 'center', gap: 'km2' }}>
        <Styled.CheckAILogo />
        <FuelTooltip
          placement="top-start"
          content="Algumas seguradoras pedem este documento em sinistros, com cadastro ou consulta na GR"
        >
          <Styled.IconWrapper>
            <FuelIcon name="info" size="micro" iconStyle="filled" />
          </Styled.IconWrapper>
        </FuelTooltip>
      </FuelFlex>
      <FuelButton variant="secondary" fullWidth={isMobile} onClick={handleClick} size="small" trailingIcon="download">
        Baixar perfil verificado
      </FuelButton>
    </FuelFlex>
  );
};

export default DownloadVerifiedProfile;
